<template>
  <div class="music-menu" @scroll="handleScroll">
    <div class="music-menu-top">
      <MenuHeader title="音乐" />
      <TagMenu v-model="currentOp" :tagList="tagList" />
      <a-input-group class="filter-box">
        <MusicFilter
          :currentOp="currentOp"
          :order.sync="order"
          :startTime.sync="filterStartTime"
          :endTime.sync="filterEndTime"
          @fetchMusicList="fetchMusicList"
          class="ant-input-group-addon"
        />
        <a-input-search
          placeholder="请输入搜索关键字"
          @search="onSearch"
          class="music-info-input"
        />
      </a-input-group>
      <a-button
        v-show="currentOp === 'myMusic'"
        type="primary"
        block
        @click="openUploadModal"
        style="margin-top: 10px"
      >
        上传本地文件
      </a-button>
      <material-category
        v-show="currentOp === 'public'"
        :list="musicCategoryList"
        :selected="categoryId"
        @itemClick="changeCategory"
        :height.sync="categoryHeight"
        :collapsed.sync="categoryCollapsed"
        class="music-menu-category"
      />
    </div>
    <!-- 使loading居中 -->
    <!-- 放在spin中会闪烁loading的背景色，所以不放在spin中 -->
    <div class="empty" :style="{ height: spacerHeight + 'px' }"></div>

    <div class="music-menu-bottom">
      <a-tooltip title="上一首">
        <a-button
          shape="circle"
          class="timeline-controls__button backward"
          icon="step-backward"
          size="small"
          :disabled="!music.material_url || !music.index"
          @click="backward"
        />
      </a-tooltip>
      <a-tooltip :title="playing ? '暂停' : '播放'">
        <a-button
          shape="circle"
          class="timeline-controls__button"
          :icon="playing ? 'pause' : 'caret-right'"
          size="small"
          :disabled="!music.material_url"
          @click="togglePlay"
        />
      </a-tooltip>
      <a-tooltip title="下一首">
        <a-button
          shape="circle"
          class="timeline-controls__button forward"
          icon="step-forward"
          size="small"
          :disabled="!music.material_url || music.index == musicList.length - 1"
          @click="forward"
        />
      </a-tooltip>
      <div class="music-menu-bottom__info" v-if="music.material_url">
        <div class="music-menu-bottom__name">
          {{ music.material }}
        </div>
        <div class="music-menu-bottom__current">
          {{ formatTime(currentTime) }}/{{ formatTime(musicDuration) }}
        </div>
      </div>
    </div>

    <music-info
      ref="musicInfo"
      :loadingStatus="loadingStatus"
      :currentOp="currentOp"
      :editing="audioEditing"
      :dataList="musicList"
      @top="handleTop"
      @delete="handleDelete"
      :music.sync="music"
      :currentTime.sync="currentTime"
    />
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import { message } from 'ant-design-vue';
import MenuHeader from '../base/MenuHeader';
import MusicInfo from './MusicInfo';
import TagMenu from "../base/TagMenu";
import MusicFilter from "../base/MusicFilter";
import { getAudioDuration } from '../../utils';
import MaterialCategory from '../material/MaterialCategory';
import moment from 'moment';

export default {
  name: "MusicMenu",
  components: { MenuHeader, MusicInfo, TagMenu, MusicFilter, MaterialCategory },
  data() {
    return {
      loadMore: 0,
      tagList: [
        { tag: "音频库", op: "public" },
        { tag: "我的音频", op: "myMusic" },
      ],
      currentOp: "public",
      loadingStatus: "loaded",
      page: 1,
      order: 'order',
      material: '',
      music: {},
      musicDuration: 0,
      currentTime: 0,
      filterStartTime: null,
      filterEndTime: null,
      categoryId: '',
      categoryCollapsed: true,
      categoryHeight: 0
    };
  },
  computed: {
    ...mapState(['audioEditing', 'uploadModalMarker', 'musicList', 'musicCategoryList']),
    u_id() {
      return this.currentOp === "myMusic" ? "" : "0";
    },
    fetchMarker() {
      return [
        this.currentOp === 'myMusic' ? this.uploadModalMarker : this.categoryId,
        this.material,
        this.u_id
      ].join(',');
    },
    playing: {
      get() {
        return this.$store.state.musicMenuIsPlaying;
      },
      set(value) {
        this.handleMusicMenuIsPlaying(value);
      }
    },
    spacerHeight() {
      return this.currentOp === 'myMusic' ? 172 : 122 + this.categoryHeight;
    }
  },
  methods: {
    ...mapMutations(["handleMusicList", 'handleUploadModalShow', 'handleUploadModalType', 'handleLoading', 'handleMusicMenuIsPlaying']),
    ...mapActions(["getMusicList", "handleUploadFile", 'setMaterialTop', 'deleteMaterial']),

    openUploadModal() {
      this.handleUploadModalShow(true);
      this.handleUploadModalType(4); // audio
    },
    handleScroll() {
      const menu = this.$el;
      if (
        this.loadingStatus !== 'loading'
        && menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 30
      ) {
        this.loadMore++;
      }
    },
    onSearch: function (material) {
      this.material = material;
    },
    fetchMusicList: function (getMore = false) {
      if (!getMore) {
        // this.handleCurrentMusic({});
        this.page = 1;
        this.handleMusicList([]);
        this.lastPage = false;
      }
      const { order, page, material, u_id, lastPage } = this;
      if (lastPage) {
        return;
      }
      let gt_duration = moment.duration(this.filterStartTime).as('seconds')
      let lt_duration = moment.duration(this.filterEndTime).as('seconds')
      this.loadingStatus = "loading";
      this.getMusicList({
        order: this.currentOp === 'myMusic' ? undefined : order,
        page,
        material,
        u_id,
        gt_duration,
        lt_duration,
        category: this.currentOp === 'public' && this.categoryId || 0
      }).then(val => {
        if (val) {
          this.lastPage = val.lastPage;
          this.page++;
          this.loadingStatus = "loaded";
        }
      });
    },
    async handleTop({ id, value }) {
      this.handleLoading(true);
      await this.setMaterialTop({ id, value });
      message.info(value ? '置顶成功' : '取消置顶成功');
      await this.fetchMusicList();
      this.handleLoading(false);
    },
    handleDelete(id) {
      this.deleteMaterial({
        id,
        done: this.fetchMusicList
      });
    },
    backward() {
      this.playing = false
      let index = this.music.index - 1
      this.music = this.musicList[index]
      this.$refs.musicInfo.togglePlay(this.music, index);
    },
    togglePlay() {
      this.playing = !this.playing;
    },
    forward() {
      this.playing = false
      let index = this.music.index + 1
      this.music = this.musicList[index]
      this.$refs.musicInfo.togglePlay(this.music, index);
    },
    formatTime(t) {
      let seconds = Math.floor(t);
      let minutes = Math.floor(seconds / 60);
      seconds %= 60;

      return [
        minutes,
        ('0' + seconds).slice(-2)
      ].join(':');
    },
    changeCategory(e) {
      this.categoryId = e.id;
    }
  },
  watch: {
    loadMore() {
      this.loadingStatus !== "loading" && this.fetchMusicList(true);
    },
    fetchMarker() {
      this.fetchMusicList();
    },
    'music.material_url'(value) {
      getAudioDuration(value).then(duration => {
        this.musicDuration = duration;
      });
    },
    currentOp: {
      immediate: true,
      handler(val) {
        if (val === 'public') {
          this.categoryCollapsed = true;
          this.categoryId = '';
        }
      }
    }
  },
  mounted() {
    this.fetchMusicList();
  }
};
</script>

<style scoped>
.filter-box {
  display: flex;
  align-items: center;
  margin-top: 13px;
}
.music-info-option {
  margin-right: 0;
  margin-top: 0;
  display: none;
}

.music-info-option--visible {
  display: block;
}
.music-info-option ::v-deep .ant-select-selection {
  border-color: #d9d9d9;
  height: 32px;
  border-radius: 4px 0 0 4px;
  border-right: 0;
}
.music-info-option ::v-deep .ant-select-sm .ant-select-selection__rendered {
  line-height: 30px;
}

.music-info-option--visible + .music-info-input ::v-deep .ant-input {
  border-radius: 0 4px 4px 0;
}

.music-menu {
  padding: 10px 14px;
  /* background: rgba(248, 248, 248, 1); */
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 80px;
  overflow-x: hidden;
}
.music-menu-top,
.music-menu-bottom {
  padding: 10px 17px 10px 0;
  position: absolute;
  z-index: 3;
  background: #f7f8f9;
  width: 253px;
  box-sizing: border-box;
}

.music-menu-top {
  top: 0;
}

.music-menu-bottom {
  bottom: 0;
  height: 50px;
  display: flex;
  align-items: center;
}

.music-menu-bottom:before {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 17px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.music-menu-bottom__info {
  width: calc(100% - 70px);
  margin-left: 4px;
}

.music-menu-bottom__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.music-menu-bottom__current {
  font-size: 12px;
  opacity: 0.7;
}

.empty {
  transition: 100ms;
}

.timeline-controls__button.ant-btn {
  margin: 0 2px;
}
.timeline-controls__button.ant-btn.backward,
.timeline-controls__button.ant-btn.forward {
  width: 16px;
  min-width: 16px;
  height: 16px;
  border: 0 !important;
}

.music-menu-category {
  margin-bottom: -10px;
}
</style>

